import PlanImpressionPrixController from './plan.impression.prix.controller';
import planImpressionPrixHtml from './plan.impression.prix.html';

export default {
	bindings: {
		domaine: '@',
		clientId: '=',
		modalInstance: '=',
		currentDomainData: '='
	},
	template: planImpressionPrixHtml,
	controller: PlanImpressionPrixController
};
